import { Tabs, Flex } from "antd";
import { useTranslation } from "react-i18next";

import { NotificationsList } from "@/modules/notifications/notifications-list";
import { NotificationsMarkAllButton } from "@/modules/notifications/notifications-mark-all-button";
import { NotificationsSettingsButton } from "@/modules/notifications/notifications-settings-button";
import { NotificationsViewProvider } from "@/modules/notifications/notifications-view";

export const NotificationsTabs = () => {
  const { t } = useTranslation();

  const STORAGE_KEY = "notifications-tabs-active-key";
  const defaultActiveKey = localStorage.getItem(STORAGE_KEY) ?? "all";

  const onTabChange = (key: string) => {
    localStorage.setItem(STORAGE_KEY, key);
  };

  return (
    <Tabs
      size="small"
      destroyOnHidden
      defaultActiveKey={defaultActiveKey}
      onChange={onTabChange}
      tabBarExtraContent={
        <Flex gap="4px" align="center">
          <NotificationsMarkAllButton type="link" size="small" />
          <NotificationsSettingsButton
            tooltip={{ placement: "bottomRight", align: { offset: [13, 8] } }}
          />
        </Flex>
      }
      items={[
        {
          key: "all",
          label: t("notification:all"),
          children: (
            <NotificationsViewProvider view="all_tab">
              <NotificationsList />
            </NotificationsViewProvider>
          ),
        },
        {
          key: "unread",
          label: t("notification:unread"),
          children: (
            <NotificationsViewProvider view="unread_tab">
              <NotificationsList />
            </NotificationsViewProvider>
          ),
        },
      ]}
    />
  );
};
